import Api from '@/services/api';
import qs from 'querystring';

export default {
  search(params, filters = [], hiddenFilter = '', page = 1, sortBy = 'date', sortDesc = false, fetchFacets = true) {

    return Api().post('/client/warrants/search', qs.stringify({
      'search': JSON.stringify(params),
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
      'fetchFacets': fetchFacets
    }));
  },
  documents() {
    return Api().get('/client/warrants/documents');
  },
  print_md(data) {
    return Api().get('/client/warrants/md-PDF/' + data.dsmId);
  },
  settlementsPDF(data) {
    return Api().get('/client/warrants/settlements-PDF/' + data.type);
  },
  confirm_reminders(data) {
    return Api().get('/client/warrants/confirm-reminders/' + data.type + '/' + data.envoi);
  },
  confirm_courriers(data) {
    return Api().get('/client/warrants/confirm-courriers/' + data.dsmId);
  },
  cleanWarrant(id) {
    return Api().post('/client/warrant/' + id + '/clean');
  },
  open(id, data) {
    return Api().post('/client/warrant/' + id + '/open', qs.stringify({ data: JSON.stringify(data) }));
  },
  get(id) {
    return Api().get('/client/warrant/' + id);
  },
  get_warrants_stop() {
    return Api().get('/client/warrants-stop');
  },
  send_acks() {
    return Api().post('/client/warrants/send-acks')
  },
  cloturePdf(id, date, body) {
    return Api().post('/client/warrant/' + id + '/stop/pdf', qs.stringify({
      date, body
    }));
  },
  clotureBody(id, date, reasons) {
    return Api().post('/client/warrant/' + id + '/stop/body', qs.stringify({
      date, reasons: JSON.stringify(reasons)
    }));
  },

  update(id, data, recompute, sync, send_mail_cloture) {
    return Api().post('/client/warrant/' + id, qs.stringify({ data: JSON.stringify(data), recompute, sync, send_mail_cloture }));
  },
  invoices(id) {
    return Api().get('/client/warrant/' + id + '/invoices')
  },
 
  invoice(data) {
    return Api().get('/client/warrant/' + data.warrant_id + '/invoice/' + data.invoice_id);
  },
 
  delete_note(data) {
    return Api().delete('/client/warrant/' + data.warrant_id + '/note/' + data.note_id);
  },
  read_notes(data) {
    return Api().get('/client/warrant/' + data.warrant_id + '/read-notes');
  },
  update_note(data) {
    return Api().post('/client/warrant/' + data.warrant_id + '/note/' + data.note_id, qs.stringify({ data: JSON.stringify(data.note) }));
  },
  create_note(data) {
    return Api().post('/client/warrant/' + data.warrant_id + '/note', qs.stringify({ data: JSON.stringify(data.note) }));
  },
  note(data) {
    return Api().get('/client/warrant/' + data.warrant_id + '/note/' + data.note_id);
  },
  unread_notes() {
    return Api().get('/client/warrants/unread-notes');
  },
  indemnities(id) {
    return Api().get('/client/warrant/' + id + '/indemnities')
  },
  updateIndemnities(id) {
    return Api().get('/client/warrant/' + id + '/update-indemnities')
  },
  summary(id) {
    return Api().get('/client/warrant/' + id + '/summary')
  },
  evolution(id) {
    return Api().get('/client/warrant/' + id + '/evolution');
  },
 
}